import {FilterCriteria} from "../../filter/api/filter.criteria";
import {ObjectRequestList} from "../../dto/object/request/object-request-list";


export class IndicatorButton {
    objectType: string;
    label: string;
    filter: FilterCriteria[];
    overlayPosition: string;
    objectRequest: ObjectRequestList;
    widgetType: string = 'list';

    constructor(
        objectType: string,
        label: string,
        filter: FilterCriteria[],
        overlayPosition: string,
        objectRequest: ObjectRequestList,
        widgetType: string = 'list'
    ) {
        this.objectType = objectType;
        this.label = label;
        this.filter = filter;
        this.overlayPosition = overlayPosition;
        this.objectRequest = objectRequest;
        this.widgetType = widgetType;
    }
}
